import React from 'react';
import { Core } from './core/Core';

const App = () => {
  return <Core></Core>;
};

export default App;
